export const RANK_LIMIT = 50

// chart metric keys the rank limit applies to
const RANK_CHART_KEYS = ['organicRanks_keywords', 'otherRanks_keywords_advertising']

export const isRankChartKey = (key) => RANK_CHART_KEYS.includes(key)

export const formatRankValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return 'NA'
  }

  const numeric = Number(value)

  if (Number.isNaN(numeric)) {
    return 'NA'
  }

  if (numeric > RANK_LIMIT) {
    return `>${RANK_LIMIT}`
  }

  return numeric.toFixed(Number.isInteger(numeric) ? 0 : 2)
}
